const subscriptionKeys = {
    all: () => [{ entity: 'subscription' }],
    allDetails: () => [{ ...subscriptionKeys.all()[0], scope: 'detail' }],
    detail: () => [{ ...subscriptionKeys.allDetails()[0] }],
};

export default subscriptionKeys;
